import { render, staticRenderFns } from "./onError.vue?vue&type=template&id=21edf3b4"
import script from "./onError.vue?vue&type=script&lang=js"
export * from "./onError.vue?vue&type=script&lang=js"
import style0 from "./onError.vue?vue&type=style&index=0&id=21edf3b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports